import useConfig from '@sdk/config/useConfig';

export function useShiftTaskAttachmentsFeatureFlag() {
  const {
    FEATURE_FLAGS: { SHIFT_TASK_ATTACHMENTS_ENABLED },
  } = useConfig();

  return {
    areAttachmentsEnabled: SHIFT_TASK_ATTACHMENTS_ENABLED,
  };
}
